import { render, staticRenderFns } from "./feature2.vue?vue&type=template&id=0eff17b4&scoped=true&"
import script from "./feature2.vue?vue&type=script&lang=js&"
export * from "./feature2.vue?vue&type=script&lang=js&"
import style0 from "./feature2.vue?vue&type=style&index=0&id=0eff17b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff17b4",
  null
  
)

export default component.exports